import { FormContainer } from 'components';
import { useTranslation } from 'libs/i18n';

import {
  CompanyGlobalFinancialMonitoringPartTwoFormType,
  FormErrors,
  getSchema,
} from '../../forms/companyGlobalFinancialMonitoringPartTwoForm';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {
  initialValues?: CompanyGlobalFinancialMonitoringPartTwoFormType;
  onSubmit: (values: CompanyGlobalFinancialMonitoringPartTwoFormType) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  formError?: FormErrors;
  submitLoading?: boolean;
}

export const CompanyGlobalFinancialMonitoringPartTwo = ({
  initialValues,
  canGoBack,
  onGoBack,
  submitLoading,
  formError,
  onSubmit,
  ...formProps
}: Props) => {
  const { t } = useTranslation();
  const schema = getSchema();

  return (
    <FormContainer
      canGoBack={canGoBack}
      initialErrors={formError}
      initialValues={initialValues}
      submitLoading={submitLoading}
      subTitle={t('onboarding.companyGlobalFinancialMonitoring.subtitle')}
      title={t('onboarding.companyGlobalFinancialMonitoring.partTwo.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <FormContent {...formProps} />
    </FormContainer>
  );
};
